import React from 'react';
import {configStore} from 'app/store/global';
import StreamsAside from 'app/components/streams/streams_aside';
import CupAside from 'app/components/pages/cup/CupAside';
import ProomPoker from 'app/components/pages/poker/ProomPoker';
import LootboxAside from 'site_version/com/aside/LootboxAside';
import {useAsideStickyTop} from 'app/utils/useAsideStickyTop';

const AsideLeft = (): React.ReactElement => {
    const {ref, top} = useAsideStickyTop(true);
    const showWidgets = !configStore.isDevelopment;

    return <aside className="aside aside--left">
        <div ref={ref} className="aside__inner" style={{top}}>
            <StreamsAside/>
            {showWidgets && <CupAside/>}
            {showWidgets && <ProomPoker embedded/>}
            <LootboxAside/>
        </div>
    </aside>;
};

export default AsideLeft;
